import { useRef, useState } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import { CertificateCorporateListdata } from "./data/CertificateCorporateList.data";

const ViewCertificateCorporateAccount = () => {
  const MemberApplicationRef = useRef();
  const [formData, setFormData] = useState(CertificateCorporateListdata);

  // 1. SGBC Product Applications data
  const applications = [
    {
      id: 1,
      category: "Civil & Structural > Steel > Reinforcing",
      productType: "Civil & Structural",
      details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      status: "Submitted",
      date: "20 Sep 2024",
    },
    {
      id: 2,
      category: "Civil & Structural > Steel > Reinforcing",
      productType: "Civil & Structural",
      details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      status: "Pending Clarification",
      date: "20 Sep 2024",
    },
    {
      id: 3,
      category: "Civil & Structural > Steel > Reinforcing",
      productType: "Civil & Structural",
      details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      status: "Pending Self Check",
      date: "20 Sep 2024",
    },
    {
      id: 4,
      category: "Civil & Structural > Steel > Reinforcing",
      productType: "Civil & Structural",
      details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      status: "Self Check Completed",
      date: "20 Sep 2024",
    },
    {
      id: 5,
      category: "Civil & Structural > Steel > Reinforcing",
      productType: "Civil & Structural",
      details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      status: "Evaluation",
      date: "20 Sep 2024",
    },
    {
      id: 6,
      category: "Civil & Structural > Steel > Reinforcing",
      productType: "Civil & Structural",
      details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      status: "Pending MUA",
      date: "20 Sep 2024",
    },
    {
      id: 7,
      category: "Civil & Structural > Steel > Reinforcing",
      productType: "Civil & Structural",
      details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor",
      status: "Approved",
      date: "20 Sep 2024",
    },
  ];

  // 2. SGBC Product Certificates data
  const productCertificates = [
    {
      id: 1,
      certNo: "SGBP 2001",
      category: "Civil & Structural > Steel > Reinforcing",
      rating: "2 Ticks (Very Good)",
      details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed",
      issued: "20 Sep 2022",
      expiry: "20 Sep 2024",
    },
    {
      id: 2,
      certNo: "SGBP 2001",
      category: "Civil & Structural > Steel > Reinforcing",
      rating: "3 Ticks (Excellent)",
      details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed",
      issued: "20 Sep 2022",
      expiry: "20 Sep 2024",
    },
    {
      id: 3,
      certNo: "SGBP 2001",
      category: "Civil & Structural > Steel > Reinforcing",
      rating: "4 Ticks (Leader)",
      details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed",
      issued: "20 Sep 2022",
      expiry: "20 Sep 2024",
    },
    {
      id: 4,
      certNo: "SGBP 2001",
      category: "Civil & Structural > Steel > Reinforcing",
      rating: "1 Tick (Good)",
      details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed",
      issued: "20 Sep 2022",
      expiry: "20 Sep 2024",
    },
    {
      id: 5,
      certNo: "SGBP 2001",
      category: "Civil & Structural > Steel > Reinforcing",
      rating: "3 Ticks (Excellent)",
      details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed",
      issued: "20 Sep 2022",
      expiry: "20 Sep 2024",
    },
  ];

  // 3. SGBC Services Applications data
  const servicesApplications = [
    {
      id: 1,
      category: "Category 1",
      description: "Environmental Sustainability Design",
      status: "Submitted",
      date: "2 Jan 2026",
    },
    {
      id: 2,
      category: "Category 1",
      description: "Environmental Sustainability Design",
      status: "Pending Clarification",
      date: "2 Jan 2026",
    },
    {
      id: 3,
      category: "Category 1",
      description: "Environmental Sustainability Design",
      status: "Pending Self Check",
      date: "2 Jan 2026",
    },
    {
      id: 4,
      category: "Category 1",
      description: "Environmental Sustainability Design",
      status: "Self Check Completed",
      date: "2 Jan 2026",
    },
    {
      id: 5,
      category: "Category 1",
      description: "Environmental Sustainability Design",
      status: "Evaluation",
      date: "2 Jan 2026",
    },
    {
      id: 6,
      category: "Category 1",
      description: "Environmental Sustainability Design",
      status: "Pending MUA",
      date: "2 Jan 2026",
    },
    {
      id: 7,
      category: "Category 1",
      description: "Environmental Sustainability Design",
      status: "Approved",
      date: "2 Jan 2026",
    },
  ];

  // 4. SGBC Services Certificates data
  const servicesCertificates = [
    {
      id: 1,
      certNo: "SGBS 0315",
      description: "Environmental Sustainability Design",
      rating: "L1",
      validity: "Valid",
      issued: "2 Jan 2024",
      validTill: "2 Jan 2026",
    },
    {
      id: 2,
      certNo: "SGBS 0315",
      description: "Environmental Sustainability Design",
      rating: "L1",
      validity: "Valid",
      issued: "2 Jan 2024",
      validTill: "2 Jan 2026",
    },
    {
      id: 3,
      certNo: "SGBS 0315",
      description: "Environmental Sustainability Design",
      rating: "-",
      validity: "Valid",
      issued: "2 Jan 2024",
      validTill: "2 Jan 2026",
    },
    {
      id: 4,
      certNo: "SGBS 2018-126",
      description: "Environmental Sustainability Design",
      rating: "L1",
      validity: "Valid",
      issued: "2 Jan 2024",
      validTill: "2 Jan 2026",
    },
    {
      id: 5,
      certNo: "SGBS 2018-126",
      description: "Environmental Sustainability Design",
      rating: "-",
      validity: "Valid",
      issued: "2 Jan 2024",
      validTill: "2 Jan 2026",
    },
  ];

  return (
    <div className="view-certificate-account-page view-certificate-corporate-account-container">
      {/* Restored Company Information Form */}
      <div className="form-card">
        <h4 className="form-card-title">Company Information</h4>
        <div className="row status-input">
          <FormCreator
            ref={MemberApplicationRef}
            {...formData}
          />
        </div>
      </div>

      {/* 1. SGBC Product Applications Table Container */}
      <div className="product-applications-card">
        <h3 className="section-heading table-card-heading">SGBC Product Applications</h3>

        <div className="table-responsive-wrapper">
          <table className="sgbc-applications-table">
            <thead>
              <tr>
                <th className="th-category">Category</th>
                <th className="th-product-type">Product Type</th>
                <th className="th-details">Product Details</th>
                <th className="th-status">Status</th>
                <th className="th-date">Submission Date</th>
                <th className="th-action"></th>
              </tr>
            </thead>
            <tbody>
              {applications.map((app) => (
                <tr key={app.id} className="table-data-row">
                  <td className="td-category">
                    {app.category.split(" > ").map((part, index, arr) => (
                      <span key={index} className="category-part">
                        {part}
                        {index < arr.length - 1 && <span className="category-arrow"> &gt; </span>}
                      </span>
                    ))}
                  </td>
                  <td className="td-product-type">{app.productType}</td>
                  <td className="td-details">{app.details}</td>
                  <td className="td-status">
                    <span className={`status-badge status-${app.status.toLowerCase().replace(/\s+/g, "-")}`}>
                      {app.status}
                    </span>
                  </td>
                  <td className="td-date">{app.date}</td>
                  <td className="td-action">
                    <button
                      type="button"
                      className="btn-view-action"
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Load More Button Container */}
        <div className="load-more-container">
          <button
            type="button"
            className="btn-load-more"
          >
            Load More
          </button>
        </div>
      </div>

      {/* 2. SGBC Product Certificates Table Container */}
      <div className="product-applications-card">
        <h3 className="section-heading table-card-heading">SGBC Product Certificates</h3>

        <div className="table-responsive-wrapper">
          <table className="sgbc-applications-table">
            <thead>
              <tr>
                <th className="th-cert-no" style={{ width: "12%" }}>Cert No.</th>
                <th className="th-category" style={{ width: "25%" }}>Category</th>
                <th className="th-rating" style={{ width: "18%" }}>Rating</th>
                <th className="th-details" style={{ width: "28%" }}>Details</th>
                <th className="th-issued" style={{ width: "10%" }}>Issued</th>
                <th className="th-expiry" style={{ width: "10%" }}>Date of Expiry</th>
                <th className="th-action" style={{ width: "3%" }}></th>
              </tr>
            </thead>
            <tbody>
              {productCertificates.map((cert) => (
                <tr key={cert.id} className="table-data-row">
                  <td className="td-cert-no font-weight-bold">{cert.certNo}</td>
                  <td className="td-category">
                    {cert.category.split(" > ").map((part, index, arr) => (
                      <span key={index} className="category-part">
                        {part}
                        {index < arr.length - 1 && <span className="category-arrow"> &gt; </span>}
                      </span>
                    ))}
                  </td>
                  <td className="td-rating">{cert.rating}</td>
                  <td className="td-details">{cert.details}</td>
                  <td className="td-issued">{cert.issued}</td>
                  <td className="td-expiry">{cert.expiry}</td>
                  <td className="td-action">
                    <button
                      type="button"
                      className="btn-view-action"
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Load More Button Container */}
        <div className="load-more-container">
          <button
            type="button"
            className="btn-load-more"
          >
            Load More
          </button>
        </div>
      </div>

      {/* 3. SGBC Services Applications Table Container */}
      <div className="product-applications-card">
        <h3 className="section-heading table-card-heading">SGBC Services Applications</h3>

        <div className="table-responsive-wrapper">
          <table className="sgbc-applications-table">
            <thead>
              <tr>
                <th className="th-category" style={{ width: "25%" }}>Category</th>
                <th className="th-description" style={{ width: "45%" }}>Description</th>
                <th className="th-status" style={{ width: "15%" }}>Status</th>
                <th className="th-date" style={{ width: "12%" }}>Submission Date</th>
                <th className="th-action" style={{ width: "3%" }}></th>
              </tr>
            </thead>
            <tbody>
              {servicesApplications.map((app) => (
                <tr key={app.id} className="table-data-row">
                  <td className="td-category">{app.category}</td>
                  <td className="td-description">{app.description}</td>
                  <td className="td-status">
                    <span className={`status-badge status-${app.status.toLowerCase().replace(/\s+/g, "-")}`}>
                      {app.status}
                    </span>
                  </td>
                  <td className="td-date">{app.date}</td>
                  <td className="td-action">
                    <button
                      type="button"
                      className="btn-view-action"
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Load More Button Container */}
        <div className="load-more-container">
          <button
            type="button"
            className="btn-load-more"
          >
            Load More
          </button>
        </div>
      </div>

      {/* 4. SGBC Services Certificates Table Container */}
      <div className="product-applications-card">
        <h3 className="section-heading table-card-heading">SGBC Services Certificates</h3>

        <div className="table-responsive-wrapper">
          <table className="sgbc-applications-table">
            <thead>
              <tr>
                <th className="th-cert-no" style={{ width: "15%" }}>Cert No.</th>
                <th className="th-description" style={{ width: "35%" }}>Description</th>
                <th className="th-rating" style={{ width: "12%" }}>Rating</th>
                <th className="th-validity" style={{ width: "12%" }}>Validity</th>
                <th className="th-issued" style={{ width: "11%" }}>Issued</th>
                <th className="th-valid-till" style={{ width: "12%" }}>Valid Till</th>
                <th className="th-action" style={{ width: "3%" }}></th>
              </tr>
            </thead>
            <tbody>
              {servicesCertificates.map((cert) => (
                <tr key={cert.id} className="table-data-row">
                  <td className="td-cert-no">
                    <button type="button" className="btn-cert-link font-weight-bold">
                      {cert.certNo}
                    </button>
                  </td>
                  <td className="td-description">{cert.description}</td>
                  <td className="td-rating">{cert.rating}</td>
                  <td className="td-validity">{cert.validity}</td>
                  <td className="td-issued">{cert.issued}</td>
                  <td className="td-valid-till">{cert.validTill}</td>
                  <td className="td-action">
                    <button
                      type="button"
                      className="btn-view-action"
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Load More Button Container */}
        <div className="load-more-container">
          <button
            type="button"
            className="btn-load-more"
          >
            Load More
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewCertificateCorporateAccount;
